import React from "react";

const TableLog = ({
  items,
  CUSPP,
  setOpenModalConfirmLogQuote,
  setQuoteSelected,
}) => {
  const requote = (item) => {
    setOpenModalConfirmLogQuote(true);
  };

  return (
    <div className="md-g-wapper__container__table">
      <div className="table-container">
        <table align="center" className="tablenew tablelog">
          <thead>
            <tr>
              <th
                data-field="id"
                className="md-g-wapper__container__table__item"
              >
                MODALIDAD
              </th>
              <th
                data-field="name"
                className="md-g-wapper__container__table__item"
              >
                MONEDA
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                FEC. PROCESAMIENTO
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                ESTADO
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                MOTIVO ERROR
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                ACCIONES
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((value, key) => {
              return (
                <tr key={key}>
                  <td className="md-g-wapper__container__table__item">
                    {value.modalidad}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.moneda}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.fecProcesamiento}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.state}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    {value.motivoError}
                  </td>
                  <td className="md-g-wapper__container__table__item">
                    <div
                      className="action-container__btn"
                      onClick={() => requote(value)}
                    >
                      <span>Recotizar</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default TableLog;
